import React from 'react';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { StyledQuestionFieldContainer } from '../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import { ErrorMessage } from '../Services/styled-components';
import { InputProps } from './types';
import { Checkbox } from '@material-ui/core';

interface SwitchEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {}

function CheckboxEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
}: SwitchEditorProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <StyledQuestionFieldContainer>
          <Checkbox
            checked={field.value}
            onChange={field.onChange}
            disabled={false}
            value={field.value}
          />
          <ErrorMessage>{fieldState.error?.message}</ErrorMessage>
        </StyledQuestionFieldContainer>
      )}
    />
  );
}

export default CheckboxEditor;
